import { ChangeDetectorRef, Inject, Component, OnInit } from '@angular/core';
import { RecaptchaModule } from 'ng-recaptcha';


import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';

import { NotesService } from '../../services/notes/notes.service';

@Component({
  selector: 'app-work',
  imports: [CommonModule, FormsModule, RecaptchaModule],
  templateUrl: './work.html',
  styleUrl: './work.css'
})

export class Work implements OnInit{

  firstname = '';
  lastname = '';
  email='';
  phone = '';
  numberpeople = '';
  date='';
  time='';
  location='';
  referral='';

  showForm = true;

  siteKey = '6LcwYiEsAAAAAKNFXXwbMMRsFv11pvJX4PzYWLD8';
  captchaToken = '';


  constructor(private cdRef: ChangeDetectorRef, private notesService: NotesService) {
    console.log('Loading Work')
  }

  ngOnInit() {
    console.log('Work::Init');
    
  }


   public submitForm(event: any): void { 
    console.log('------ '+event);

    let formSubmission = { 'body': {
        'firstname': this.firstname,
        'lastname': this.lastname,
        'email': this.email,
        'phone': this.phone,
        'numberpeople': this.numberpeople,
        'date': this.date,
        'time':this.time,
        'location': this.location,
        'referral': this.referral,
        'captchatoken' : this.captchaToken,
        'app' : 'tpdg'
      }
    };

    console.log("submitting form: "+JSON.stringify(formSubmission));

    this.showForm = false;

    this.notesService.submitInquiry(JSON.stringify(formSubmission)).subscribe(data => {
      console.log('DONE: ')
      this.cdRef.detectChanges();

    });

  }

  getMinDate(){
   var today = new Date();
  var mindate = new Date(new Date().setDate(today.getDate() + 21));
  return mindate.toLocaleDateString('en-CA');

    
  }


  onCaptchaResolved(token: any) {
    this.captchaToken = token;
  }

}
